module.exports = __webpack_public_path__ + "files/d22e1b243cb89609b28dd814edae2a62.png";